import { Ride } from 'grids/ride/ride';
import { GridContainer } from 'libs/ui';

export const RideWrapper = (props) => {
  return (
    <GridContainer>
      <Ride {...props} />
    </GridContainer>
  );
};
